import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, propertyName: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    let data = [];
    if (!propertyName) {
      data = items.filter(it => it != null && String(it).toLocaleLowerCase().includes(searchText));
    }
    else {
      data = items.filter(it => {
        const v = it == null ? null : it[propertyName];
        return v != null && String(v).toLocaleLowerCase().includes(searchText);
      });
    }
    return data;
  }

}
